module.exports = __webpack_public_path__ + "img/track&trace.ee9a7c06.png";